export default __webpack_public_path__ + "static/media/gamebetflix2.6713dabd.png";